"use strict";

exports.__esModule = true;
exports.DEFAULT_PROPS = void 0;
var DEFAULT_PROPS = {
  pageData: {
    id: 'language-masters_en_1599828992884',
    resourceType: 'DealerLocator_1_0_0',
    lastModified: '1599828992884',
    title: 'Find your nearest dealership',
    subHeadline: null,
    searchHelpText: 'Enter Business name or location',
    locationCtaLabel: 'Use my current location',
    serviceSearchFilterLabel: 'Service',
    salesSearchFilterLabel: 'Test Drive',
    allDealershipsSearchFilterLabel: 'All Dealerships',
    getDirectionsLabel: 'Get Directions',
    testDriveCTA: {
      URL: '/en/cars',
      label: 'Test Drive',
      openNewTab: false,
      __typename: 'Link'
    },
    carServiceCTA: {
      URL: '',
      label: 'Car Service',
      openNewTab: false,
      __typename: 'Link'
    },
    searchRadius: 50,
    showRating: true,
    searchResultsFoundLabel: 'Mitsubishi Motors dealerships near ',
    saleOpeningHoursLabel: 'Sales opening hours',
    serviceOpeningHoursLabel: 'Service opening hours',
    contactLabel: 'Contact',
    metricSystem: 'metric',
    viewMoreText: null,
    noGeolocationMessage: 'Cannot locate your current location',
    noDealershipFoundMessage: 'No dealership have been found in this location. Please try another location or change your search term.',
    salesLabel: 'Sales',
    servicesLabel: 'Services',
    bodyAndPaintLabel: 'Body And Paint',
    usedCarsSalesLabel: 'Used Cars Sales',
    listLabel: 'Dealers list',
    mapLabel: 'Map',
    __typename: 'DealerLocator',
    errorNoDealershipsLabel: 'Sorry, no dealerships in your location',
    errorNoGeolocationLabel: 'Sorry, your current location is unavailable'
  },
  searchValue: '',
  isInitialMapLoad: false,
  loading: false,
  showList: false,
  radius: 2000,
  defaultRadius: 2000,
  market: 'gb',
  noDealersFound: false,
  placeChanged: false,
  googleMapSettings: {
    zoom: 12,
    center: {
      lat: 53.480759,
      lng: -2.242631
    }
  },
  userLocation: {
    lat: 53.480759,
    lng: -2.242631
  },
  defaultLocation: {
    lat: 53.480759,
    lng: -2.242631
  },
  data: {
    searchDealer: [{
      name: 'West London Mitsubishi',
      id: 1245,
      dealershipMarketId: '000418',
      url: 'https://www.westlondon-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@westlondonmitsubishi.dealers.mitsubishi-cars.co.uk',
      rating: 4,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '0208 748 8844',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: '4 Castelnau',
        addressLine2: 'Barnes',
        addressLine3: 'London',
        postalArea: 'SW13 9RU',
        municipality: '',
        district: 'London',
        longitude: -0.238274,
        latitude: 51.476882,
        city: '',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 8.39,
      pinLabel: 'A'
    }, {
      name: 'Humming Bird Mitsubishi',
      id: 1291,
      dealershipMarketId: '000774',
      url: 'https://www.hummingbird-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@hummingbirdmotorsfinchleyltd.dealers.mitsubishi-cars.co.uk',
      rating: 4.5,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '020 8200 2200',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: '363 Edgware Road',
        addressLine2: 'Colindale',
        addressLine3: 'London',
        postalArea: 'NW9 6AF',
        municipality: '',
        district: 'London',
        longitude: -0.257015,
        latitude: 51.591367,
        city: '',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 12.95,
      pinLabel: 'B'
    }, {
      name: 'Masters Mitsubishi',
      id: 1197,
      dealershipMarketId: '000128',
      url: 'https://www.masters-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@bromleymitsubishi.dealers.mitsubishi-cars.co.uk',
      rating: 4.5,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '0208 777 0901',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: '850 Wickham Road',
        addressLine2: 'Shirley',
        addressLine3: 'Surrey',
        postalArea: 'CR0 8ED',
        municipality: '',
        district: 'London',
        longitude: -0.02631,
        latitude: 51.37708,
        city: '',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 16.12,
      pinLabel: 'C'
    }, {
      name: 'North City Autos (Chingford)',
      id: 1234,
      dealershipMarketId: '000379',
      url: 'https://www.northcityautos-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: '',
      rating: 3.5,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '0208 524 8855',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: '174-180 Station Road',
        addressLine2: 'Chingford',
        addressLine3: 'London',
        postalArea: 'E4 6AN',
        municipality: '',
        district: 'London',
        longitude: 0.009816,
        latitude: 51.63386,
        city: '',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 17,
      pinLabel: 'D'
    }, {
      name: 'Mitsubishi Lakeside',
      id: 1275,
      dealershipMarketId: '000470',
      url: 'https://www.mitsubishi-motors.co.uk/lakeside',
      carServiceCTA: null,
      testDriveCTA: null,
      email: '',
      rating: null,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '0333 880 2987',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: 'Unit 73',
        addressLine2: 'Thurrock Lakeside',
        addressLine3: 'Shopping Centre',
        postalArea: 'RM20 2ZP',
        municipality: '',
        district: 'East',
        longitude: 0.283086,
        latitude: 51.487062,
        city: 'West Thurrock',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 28.62,
      pinLabel: 'E'
    }, {
      name: 'Palmers Mitsubishi',
      id: 1267,
      dealershipMarketId: '000458',
      url: 'https://www.palmers-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@palmersmitsubishi.dealers.mitsubishi-cars.co.uk',
      rating: 4,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '01442 232300',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: 'Pennine Way',
        addressLine2: 'Redbourn Road',
        addressLine3: 'Hemel Hempstead',
        postalArea: 'HP2 7AZ',
        municipality: '',
        district: 'South East',
        longitude: -0.44966,
        latitude: 51.76909,
        city: '',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 36.67,
      pinLabel: 'F'
    }, {
      name: 'Gatwick Mitsubishi',
      id: 1256,
      dealershipMarketId: '000438',
      url: 'https://www.gatwick-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@gatwickmitsubishi.dealers.mitsubishi-cars.co.uk',
      rating: 5,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '01293 429800',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: 'BCL House,',
        addressLine2: 'Gatwick Road',
        addressLine3: 'Crawley',
        postalArea: 'RH10 9AX',
        municipality: '',
        district: 'South East',
        longitude: -0.166885,
        latitude: 51.133541,
        city: 'West Sussex',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 41.68,
      pinLabel: 'G'
    }, {
      name: 'Humphries & Parks Mitsubishi',
      id: 1203,
      dealershipMarketId: '000176',
      url: 'https://www.humphriesandparks-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@humphriesandparksltd.dealers.mitsubishi-cars.co.uk',
      rating: 4,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '01732 870711',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: 'London Road',
        addressLine2: 'West Malling',
        addressLine3: 'Maidstone',
        postalArea: 'ME19 5AN',
        municipality: '',
        district: 'South East',
        longitude: 0.385161,
        latitude: 51.303373,
        city: 'Kent',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 42.3,
      pinLabel: 'H'
    }, {
      name: 'Maidenhead Mitsubishi',
      id: 1247,
      dealershipMarketId: '000423',
      url: 'https://www.maidenhead-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@maidenheadmitsubishi.dealers.mitsubishi-cars.co.uk',
      rating: 4,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '01628 822543',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: 'A4 Bath Road',
        addressLine2: 'Littlewick Green',
        addressLine3: 'Maidenhead',
        postalArea: 'SL6 3RQ',
        municipality: '',
        district: 'South East',
        longitude: -0.793974,
        latitude: 51.514899,
        city: 'Berkshire',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 46.26,
      pinLabel: 'I'
    }, {
      name: 'Glyn Hopkin Chelmsford',
      id: 2876,
      dealershipMarketId: '000499',
      url: 'https://www.glynhopkin-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@glynhopkinmitsubishi.dealers.mitsubishi-cars.co.uk',
      rating: null,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '01245 245313',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: 'Unit 8',
        addressLine2: 'Waterhouse Lane',
        addressLine3: 'Chelmsford',
        postalArea: 'CM1 2UP',
        municipality: '',
        district: 'South East',
        longitude: 0.45319,
        latitude: 51.729252,
        city: 'Essex',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 47.21,
      pinLabel: 'J'
    }, {
      name: 'Normandy Garage Mitsubishi',
      id: 1257,
      dealershipMarketId: '000440',
      url: 'https://www.normandygarage-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@normandygarage.dealers.mitsubishi-cars.co.uk',
      rating: 5,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '01483 811111',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: 'Guildford Road',
        addressLine2: 'Normandy',
        addressLine3: 'Guildford',
        postalArea: 'GU3 2DA',
        municipality: '',
        district: 'South East',
        longitude: -0.676896,
        latitude: 51.255148,
        city: 'Surrey',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 47.42,
      pinLabel: 'K'
    }, {
      name: 'Grosvenor Garage',
      id: 1303,
      dealershipMarketId: '000881',
      url: 'https://www.grosvenor-mitsubishi.co.uk',
      carServiceCTA: null,
      testDriveCTA: null,
      email: 'dealerprincipal@grosvenorgarage.dealers.mitsubishi-cars.co.uk',
      rating: 4.5,
      logo: '',
      phone: {
        phoneType: null,
        countryCode: null,
        areaCode: null,
        phoneNumber: '01892 548446',
        extensionNumber: null,
        __typename: 'Phone'
      },
      address: {
        addressLine1: '123-125 St James Road',
        addressLine2: 'Tunbridge Wells',
        addressLine3: 'Kent',
        postalArea: 'TN1 2HG',
        municipality: '',
        district: 'South East',
        longitude: 0.271986,
        latitude: 51.140694,
        city: '',
        __typename: 'Address'
      },
      dealerDepartments: [],
      __typename: 'Dealer',
      distance: 49.4,
      pinLabel: 'L'
    }]
  }
};

// eslint-disable-next-line import/prefer-default-export
exports.DEFAULT_PROPS = DEFAULT_PROPS;